<style lang="scss" src="./booking-infrastructure-drawer.scss"></style>

<template>
  <a-drawer
    :open="open"
    root-class-name="booking-infrastructure-drawer"
    class="booking-infrastructure-drawer"
    @close="onClose"
  >
    <template #title>
      <span class="booking-infrastructure-drawer__header-title"> Бронирование инфраструктуры </span>
    </template>

    <template #closeIcon>
      <span class="booking-infrastructure-drawer__close-trigger">
        <CloseOutlined />
      </span>
    </template>

    <div class="booking-infrastructure-drawer__section">
      <span class="booking-infrastructure-drawer__section-title">1. Общее</span>

      <a-form
        ref="generalFormRef"
        :model="form"
        :rules="rules"
        layout="vertical"
        class="booking-infrastructure-drawer__form"
      >
        <div class="booking-infrastructure-drawer__section-content-container">
          <div class="booking-infrastructure-drawer__row">
            <a-form-item class="stc-ant-field-skin" label="Кластер" name="cluster" required>
              <a-select v-model:value="form.cluster" placeholder="Выберите кластер">
                <a-select-option
                  v-for="opt in clusterOptions"
                  :key="opt.value"
                  :value="opt.value"
                  >{{ opt.label }}</a-select-option
                >
              </a-select>
            </a-form-item>

            <a-form-item class="stc-ant-field-skin" label="Помещение" name="premise" required>
              <a-select v-model:value="form.premise" placeholder="Выберите помещение">
                <a-select-option
                  v-for="opt in premiseOptions"
                  :key="opt.value"
                  :value="opt.value"
                  >{{ opt.label }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </div>

          <a-form-item
            class="stc-ant-field-skin"
            label="Название организации"
            name="organizationName"
            required
          >
            <a-input
              v-model:value="form.organizationName"
              placeholder="Введите название организации"
            />
          </a-form-item>

          <div class="booking-infrastructure-drawer__row">
            <a-form-item
              class="stc-ant-field-skin"
              label="Дата мероприятия"
              name="eventDate"
              required
            >
              <a-date-picker
                v-model:value="form.eventDate"
                :locale="pickerLocale"
                format="DD.MM.YYYY"
                placeholder="Выберите дату"
                style="width: 100%"
              />
            </a-form-item>

            <a-form-item class="stc-ant-field-skin" label="Время начала" name="startTime" required>
              <a-time-picker
                v-model:value="form.startTime"
                :locale="pickerLocale"
                format="HH:mm"
                placeholder="Время"
                style="width: 100%"
              />
            </a-form-item>

            <a-form-item
              class="stc-ant-field-skin"
              label="Продолжительность, ч"
              name="durationHours"
              required
            >
              <a-input-number
                v-model:value="form.durationHours"
                :min="1"
                :max="744"
                placeholder="Часов"
                style="width: 100%"
              />
            </a-form-item>
          </div>

          <div class="booking-infrastructure-drawer__row">
            <a-form-item
              class="stc-ant-field-skin"
              label="Формат мероприятия"
              name="eventFormat"
              required
            >
              <a-select v-model:value="form.eventFormat" placeholder="Выберите формат">
                <a-select-option
                  v-for="opt in eventFormatOptions"
                  :key="opt.value"
                  :value="opt.value"
                  >{{ opt.label }}</a-select-option
                >
              </a-select>
            </a-form-item>

            <a-form-item
              class="stc-ant-field-skin"
              label="Кол-во участников"
              name="participantCount"
              required
            >
              <a-input-number
                v-model:value="form.participantCount"
                :min="1"
                :max="100000"
                placeholder="Человек"
                style="width: 100%"
              />
            </a-form-item>
          </div>

          <a-form-item
            class="stc-ant-field-skin"
            label="Доп. услуги и оборудование"
            name="extraServicesEquipment"
          >
            <a-select
              v-model:value="form.extraServicesEquipment"
              mode="multiple"
              :show-search="false"
              allow-clear
              show-arrow
              placeholder="Выберите один или несколько вариантов"
            >
              <a-select-option
                v-for="opt in extraServicesOptions"
                :key="opt.value"
                :value="opt.value"
                >{{ opt.label }}</a-select-option
              >
            </a-select>
          </a-form-item>

          <a-form-item class="stc-ant-field-skin" label="Доп. пожелания" name="additionalWishes">
            <a-textarea
              v-model:value="form.additionalWishes"
              :auto-size="{ minRows: 4, maxRows: 8 }"
              :maxlength="ADDITIONAL_WISHES_MAX_LENGTH"
              placeholder="Опишите дополнительные пожелания"
              show-count
            />
          </a-form-item>
        </div>
      </a-form>
    </div>

    <a-divider class="booking-infrastructure-drawer__divider" />

    <div class="booking-infrastructure-drawer__section">
      <span class="booking-infrastructure-drawer__section-title">2. Контактное лицо</span>

      <a-form
        ref="contactFormRef"
        :model="form"
        :rules="rules"
        layout="vertical"
        class="booking-infrastructure-drawer__form"
      >
        <div class="booking-infrastructure-drawer__section-content-container">
          <FormFullNameField v-model:model-value="form.fullName" />

          <div class="booking-infrastructure-drawer__row">
            <FormPhoneField v-model:model-value="form.phone" :required="false" />
            <FormEmailField v-model:model-value="form.email" />
          </div>
        </div>
      </a-form>
    </div>

    <a-divider class="booking-infrastructure-drawer__mobile-divider" />

    <FormPrivacyConsentField
      v-model:model-value="form.privacy"
      class="booking-infrastructure-drawer__mobile-policy"
    />

    <template #footer>
      <div class="booking-infrastructure-drawer__footer">
        <FormPrivacyConsentField
          v-model:model-value="form.privacy"
          class="booking-infrastructure-drawer__footer-policy"
        />

        <div class="booking-infrastructure-drawer__buttons-container">
          <button type="button" class="btn btn-secondary btn-medium btn-cancel" @click="onClose">
            Отмена
          </button>
          <button
            type="button"
            class="btn btn-primary btn-medium"
            @click="onSubmit"
            :disabled="isSubmitDisabled"
          >
            {{ isSubmitting ? 'Отправка…' : 'Отправить' }}
          </button>
        </div>
      </div>
    </template>
  </a-drawer>

  <ConsultationRequestSuccessModal
    v-model:open="openModal"
    :description="successModalDescription"
  />
</template>

<script lang="ts" setup>
import { computed, nextTick, onMounted, reactive, ref, watch } from 'vue';
import { CloseOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import type { FormInstance, Rule } from 'ant-design-vue/es/form';
import FormFullNameField from '@/js/components/form/form-full-name-field.vue';
import FormPhoneField from '@/js/components/form/form-phone-field.vue';
import FormEmailField from '@/js/components/form/form-email-field.vue';
import { type FormSubjectOption } from '@/js/components/form/form-subject-field.vue';
import ConsultationRequestSuccessModal from '@/js/components/consultation-request-success-modal/consultation-request-success-modal.vue';
import { getApiUrl } from '@/js/utils/getApiUrl';
import { submitFormWithCaptcha } from '@/js/utils/submitFormWithCaptcha';
import { getRecaptchaErrorMessage } from '@/js/utils/getRecaptchaToken';
import FormPrivacyConsentField from '@/js/components/form/form-privacy-consent-field.vue';
import dayjs, { type Dayjs } from 'dayjs';
import 'dayjs/locale/ru';
import ruRu from 'ant-design-vue/es/date-picker/locale/ru_RU';

const ICONS_BASE =
  process.env.NODE_ENV === 'development'
    ? '/assets/images/icons'
    : '/local/templates/dist/assets/images/icons';
const pickerLocale = ruRu;
dayjs.locale('ru');
const ADDITIONAL_WISHES_MAX_LENGTH = 512;

interface BookingOfInfrastructureFormMetaItem {
  id: string;
  text: string;
}

interface BookingOfInfrastructureFormMetaResponse {
  status?: string;
  msg?: {
    clusters?: BookingOfInfrastructureFormMetaItem[];
    rooms?: (BookingOfInfrastructureFormMetaItem & { clusterId: string })[];
    format?: BookingOfInfrastructureFormMetaItem[];
    additional_services?: BookingOfInfrastructureFormMetaItem[];
    privacy?: BookingOfInfrastructureFormMetaItem[];
  };
}

interface BookingOpenParams {
  cluster?: string;
  premise?: string;
}

function mapMetaToOptions(
  items: BookingOfInfrastructureFormMetaItem[] | undefined,
): FormSubjectOption[] {
  return (items ?? []).map((item) => ({ value: item.id, label: item.text }));
}

const subjectOptions = ref<FormSubjectOption[]>([]);
const clusterOptions = ref<FormSubjectOption[]>([]);
const eventFormatOptions = ref<FormSubjectOption[]>([]);
const extraServicesOptions = ref<FormSubjectOption[]>([]);
const privacyOptionId = ref<string>('');
const rooms = ref<
  (BookingOfInfrastructureFormMetaItem & {
    clusterId: string;
  })[]
>([]);

const openModal = ref<boolean>(false);
const successModalDescription = ref('');
const isSubmitting = ref(false);

const showModal = () => {
  openModal.value = true;
};

const generalFormRef = ref<FormInstance>();
const contactFormRef = ref<FormInstance>();

const initialFormState = () => ({
  cluster: '',
  premise: '',
  organizationName: '',
  eventDate: null as Dayjs | null,
  startTime: null as Dayjs | null,
  durationHours: null as number | null,
  eventFormat: '',
  participantCount: null as number | null,
  extraServicesEquipment: [] as string[],
  additionalWishes: '',
  fullName: '',
  companyName: '',
  email: '',
  phone: '',
  privacy: false,
});

const form = reactive(initialFormState());
const additionalWishesLength = computed(() => form.additionalWishes.length);

const isNotBlankString = (value: string): boolean => value?.trim().length > 0;
const isValidEmail = (value: string): boolean => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());

const isRequiredFieldsFilled = computed(
  () =>
    isNotBlankString(form.cluster) &&
    isNotBlankString(form.premise) &&
    isNotBlankString(form.organizationName) &&
    form.eventDate !== null &&
    form.startTime !== null &&
    typeof form.durationHours === 'number' &&
    form.durationHours > 0 &&
    isNotBlankString(form.eventFormat) &&
    typeof form.participantCount === 'number' &&
    form.participantCount > 0 &&
    isNotBlankString(form.fullName) &&
    isNotBlankString(form.email) &&
    form.privacy,
);

const hasValidationErrors = computed(() => !isValidEmail(form.email));
const isSubmitDisabled = computed(
  () => isSubmitting.value || !isRequiredFieldsFilled.value || hasValidationErrors.value,
);

const rules: Record<string, Rule[]> = {
  cluster: [{ required: true, message: 'Выберите кластер' }],
  premise: [{ required: true, message: 'Выберите помещение' }],
  organizationName: [{ required: true, whitespace: true, message: 'Введите название организации' }],
  eventDate: [{ required: true, message: 'Выберите дату мероприятия' }],
  startTime: [{ required: true, message: 'Укажите время начала' }],
  durationHours: [{ required: true, message: 'Укажите продолжительность', type: 'number' }],
  eventFormat: [{ required: true, message: 'Выберите формат мероприятия' }],
  participantCount: [{ required: true, message: 'Укажите количество участников', type: 'number' }],
  extraServicesEquipment: [
    {
      type: 'array',
      message: 'Выберите хотя бы один вариант доп. услуг и оборудования',
    },
  ],
  additionalWishes: [{ whitespace: true, message: 'Заполните дополнительные пожелания' }],
  fullName: [{ required: true, message: 'Введите ваше полное имя' }],
  email: [{ required: true, message: 'Введите e-mail', type: 'email' }],
};

const open = ref<boolean>(false);

const openDrawer = (params?: BookingOpenParams): void => {
  resetFormState();

  if (params?.cluster) {
    form.cluster = params.cluster;
  }

  if (params?.premise) {
    form.premise = params.premise;
  }

  open.value = true;
};

const fetchBookingOfInfrastructureFormMeta = async () => {
  try {
    const response = await fetch(getApiUrl('/api/form/reservation/'), {
      method: 'GET',
      credentials: 'same-origin',
    });

    const result = (await response.json()) as BookingOfInfrastructureFormMetaResponse;

    if (!response.ok || result.status !== 'success') {
      throw new Error(result?.error ?? 'Не удалось загрузить данные формы');
    }

    const privacyList = result.msg?.privacy ?? [];

    clusterOptions.value = mapMetaToOptions(result.msg?.clusters);
    eventFormatOptions.value = mapMetaToOptions(result.msg?.format);
    extraServicesOptions.value = mapMetaToOptions(result.msg?.additional_services);
    privacyOptionId.value = privacyList[0]?.id ?? '';
    rooms.value = result.msg?.rooms ?? [];
  } catch {
    message.error('Не удалось загрузить данные формы');
  }
};

const premiseOptions = computed(() => {
  if (!form.cluster) {
    return [];
  }

  return mapMetaToOptions(rooms.value.filter((room) => room.clusterId === form.cluster));
});

watch(premiseOptions, (options) => {
  const exists = options.some((option) => option.value === form.premise);

  if (!exists) {
    form.premise = undefined;
  }
});

function parseNameParts(fullName: string): [string, string, string] {
  const parts = fullName.trim().split(/\s+/).filter(Boolean);

  const lastName = parts[0] ?? '';
  const firstName = parts[1] ?? '';
  const middleName = parts.slice(2).join(' ');

  return [lastName, firstName, middleName];
}

const resetFormState = () => {
  Object.assign(form, initialFormState());
  nextTick(() => {
    generalFormRef.value?.clearValidate();
    contactFormRef.value?.clearValidate();
  });
};

const onClose = () => {
  open.value = false;
  resetFormState();
};

const onSubmit = async () => {
  if (!generalFormRef.value || !contactFormRef.value) {
    return;
  }

  try {
    await Promise.all([generalFormRef.value.validate(), contactFormRef.value.validate()]);
  } catch {
    return;
  }

  if (form.privacy && !privacyOptionId.value) {
    message.error('Не удалось определить согласие на обработку данных');
    return;
  }

  isSubmitting.value = true;

  try {
    const submitResult = await submitFormWithCaptcha({
      endpoint: getApiUrl('/api/form/reservation/'),
      buildFormData: () => {
        const body = new FormData();
        const [lastName, firstName, middleName] = parseNameParts(form.fullName);

        body.append('email', form.email);
        body.append('phone', form.phone);
        body.append('last_name', lastName);
        body.append('first_name', firstName);
        body.append('middle_name', middleName);
        body.append('cluster', form.cluster);
        body.append('room', form.premise);
        body.append('company_name', form.organizationName);
        if (form.eventDate && form.startTime && form.durationHours != null) {
          const start = dayjs(form.eventDate)
            .hour(form.startTime.hour())
            .minute(form.startTime.minute())
            .second(0);

          const end = start.add(form.durationHours, 'hour');

          body.append('datetime_start', start.format('YYYY-MM-DD HH:mm:ss'));

          body.append('datetime_end', end.format('YYYY-MM-DD HH:mm:ss'));
        }
        body.append('format', form.eventFormat);
        if (form.participantCount != null) {
          body.append('quantity', String(form.participantCount));
        }
        form.extraServicesEquipment.forEach((item) => {
          body.append('additional_services[]', item);
        });
        body.append('project_description', form.additionalWishes);
        if (form.privacy && privacyOptionId.value) {
          body.append('privacy', privacyOptionId.value);
        }

        return body;
      },
    });

    if (!submitResult.ok || !submitResult.data) {
      if (submitResult.errorCode === 'captcha-not-loaded') {
        message.error(getRecaptchaErrorMessage('captcha-not-loaded'));
        return;
      }

      if (submitResult.errorCode === 'captcha-failed') {
        message.error(getRecaptchaErrorMessage('captcha-failed'));
        return;
      }

      message.error(submitResult.message ?? 'Не удалось отправить обращение');
      return;
    }

    successModalDescription.value = submitResult.data.msg ?? '';
    onClose();
    showModal();
  } catch {
    message.error('Ошибка соединения');
  } finally {
    isSubmitting.value = false;
  }
};

onMounted(() => {
  void fetchBookingOfInfrastructureFormMeta();
});

defineExpose({
  open: openDrawer,
});
</script>
